import React, { useState } from 'react'
import EditRoles from './AddRoles.module.css'
import { Button } from '@mui/material';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';


  // import this for redux read write
  import { useSelector, useDispatch } from 'react-redux'
  import { setNotifications } from '../../state/GlobalState'
  import { setNotificationCount } from '../../state/GlobalState'
  import { fetchNotifications } from '../../state/GlobalState'





const AddRoles = () => {

    // get data from redux
    const name=useSelector((state)=>state.globalData.name);
    const count=useSelector((state)=>state.globalData.notificationCount);
    const dispatch =  useDispatch()
    // const dispatch = useDispatch();
    const location = useLocation()
    const data = location.state
    console.log(data)

    const navigate = useNavigate()


    const [roleData, setRoleData] = useState({
        name: '',

    })



    const handleInputChange = (event) => {
        const {name, value} = event.target
        setRoleData({ ...roleData, [name]: value })
    }

    const handleSubmit = async (event) => {
        event.preventDefault()




        {
            const formDataObj = new FormData()

            formDataObj.append("name", roleData.name)





        try{
            const rolesResponse = await axios.post(
                `${process.env.REACT_APP_STEELADMIN}/superAdmin/addRole`,
                roleData,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )

            dispatch(fetchNotifications())

            dispatch(setNotificationCount({
             count:count+1,
            }))
            
            console.log('Roles Added.')
            console.log(rolesResponse)



             // this is the snipte for the notification
             console.log("heello")
    //        dispatch(fetchNotifications())

    //         const dateTime=businessResponse.data.date;

    //    const [dateString,timeString]=dateTime.split("T");

    //    const date=new Date(dateString);

    //    const time=timeString.substr(0,8);


    //    const localDate=date.toLocaleDateString();

    //    dispatch(setNotifications({
    //        notification:{
    //          name:name,
    //          details:businessResponse.data.message,
    //          time:time,
    //          date:localDate
    //        }
    //      }))
    //      dispatch(setNotificationCount({
    //       count:count+1,
    //      }))

       //   uptill here 


            alert('Roles Added.')
            navigate('/Roles')



        } catch (error) {
            console.error(error)

        }
    }
        // else {
        //     if (addressData.branchAddressName === '') {
        //       alert('Please provide the address name.');
        //       return false;
        //     } else if (addressData.branchAddressDesc === '') {
        //       alert('Please provide the address description.');
        //       return false
        //     } else {
        //       alert('Please provide the contact number.');
        //       return false;
        //     }
        //   }


    }

    return (
        <div className={EditRoles.editAddressMain}>
            <div className={EditRoles.editAddressContent}>
                <form action="" className={EditRoles.editAddressForm} onSubmit={handleSubmit}>
                    <label className={EditRoles.editAddressFormLabel}>Edit Role</label>
                    <input className={EditRoles.editAddressFormText} type="text" value={roleData.name} name='name' onChange={handleInputChange}/>
                    <Button variant='contained' type='submit' className={EditRoles.saveChanges}>Add Role</Button>
                </form>
            </div>
        </div>
    )
}

export default AddRoles









